import { useMemo } from 'react'
import {
  useQuestV2Categories as useQuestV2CategoriesQuery,
  useQuestV2Quests as useQuestV2QuestsQuery,
} from 'src/services/orpc/questV2'
import type { QuestV2, QuestV2Category } from './types'

export function useQuestV2Categories() {
  const { data } = useQuestV2CategoriesQuery()
  const categories: QuestV2Category[] = data ?? []
  return { categories }
}

export function useQuestV2Quests(options?: {
  invisibleQuests?: 'include' | 'exclude'
}) {
  const { data, refetch } = useQuestV2QuestsQuery(options)
  const quests: QuestV2[] = (data as QuestV2[] | undefined) ?? []

  const questsByCategory = useMemo(() => {
    const map = new Map<string, QuestV2[]>()
    for (const quest of quests) {
      if (!quest.categoryId) continue
      const list = map.get(quest.categoryId) ?? []
      list.push(quest)
      map.set(quest.categoryId, list)
    }
    return map
  }, [quests])

  const reload = async () => {
    await refetch()
  }

  return { quests, questsByCategory, reload }
}
